import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/baseurl";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import MDBox from "components/MDBox";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, } from '@mui/material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Tooltip from "@mui/material/Tooltip";
import { keyframes } from "@mui/system";

import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import {
  Alert,
  AlertTitle,
  Stack,
  Typography,
  CircularProgress,
   Button,
} from "@mui/material";
import DoctorModal from "track/Doctormodal";
import AlreadyPushedModal from "track/Alreadypushedmodal";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";
function NotificationDetails() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
   const [isModalOpen, setIsModalOpen] = useState(false); 
     const [selectedNotification, setSelectedNotification] = useState(null);
const [alreadyPushedOpen, setAlreadyPushedOpen] = useState(false);
const [alreadyPushedId, setAlreadyPushedId] = useState(null);

const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
    const role = loginData?.role;
 useEffect(() => {
     const fetchNotifications = async () => {
       try {
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData"))?.token;
   
           const response = await axios.get(`/api/notifications/notifications/user/${userid}`, {
           headers: { Authorization: `Bearer ${token}` },
         });
   
         if (response.status === 200) {
           const decrypted = decryptBody(response.data, secretKey);
setNotifications(decrypted.notifications || []);
          //  const unreadCount = decrypted.filter((n) => !n.read).length;
setNotificationCount(decrypted.unreadCount || 0);
         }
       } catch (err) {
         console.error("Failed to fetch customer types", err);
       }
     };
   
     fetchNotifications();
   }, []);
    const fetchNotifications = async () => {
         setLoading(true);
   
         try {
           const secretKey = await fetchSecretKey();
           const token = JSON.parse(localStorage.getItem("loginData"))?.token;
   
           if (!token) throw new Error("Authentication token not found.");
   
           const response = await axios.get(`/api/notifications/notifications/user/${userid}`, {
                
             headers: {
               Authorization: `Bearer ${token}`,
             },
           });
   
           if (response.status === 200) {
             const decryptedData = decryptBody(response.data, secretKey);
            setNotifications(decryptedData.notifications || []);
           setNotificationCount(decryptedData.unreadCount || 0);
           }
         } catch (error) {
           console.error("Error fetching device types:", error);
         
         } finally {
           setLoading(false); 
         }
       };
   
      useEffect(() => {
     fetchNotifications();
   }, []);
   const handleMarkAsRead = async (notificationId) => {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    if (!token) return;
  
    try {
      // Optimistically update UI
      setNotifications((prev) =>
        prev.map((n) =>
          n.id === notificationId ? { ...n, read: true } : n
        )
      );
  
      // Recalculate unread count
      const newUnreadCount = notifications.filter(
        (n) => n.id !== notificationId && !n.read
      ).length;
      setNotificationCount(newUnreadCount);
      const body = encryptBody({ id:notificationId }, secretKey);

      // Call backend API to mark as read (✅ Correct URL)
      await axios.post(
        `/api/notifications/markAsRead`,
         body,   // Pass the ID here
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
    }
  };
 const handleOpenModal = (notification) => {
    setSelectedNotification(notification);
    setIsModalOpen(true);
  };
const handleCloseModal = () => {
  fetchNotifications();
  setIsModalOpen(false);
};

const handleOpenAlreadyPushed = (pushId) => {
  setAlreadyPushedId(pushId);
  setAlreadyPushedOpen(true);
};
const handleCloseAlreadyPushedModal = () => {
  setAlreadyPushedOpen(false);   // close modal
  fetchNotifications();          // refresh notifications after closing
};
const handleAcceptNotification = async (notificationId, doctorId) => {
  try {
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    const secretKey = await fetchSecretKey();

    if (!token) return;

    const body = encryptBody(
      {
      notificationId:notificationId,
        userid: userid,
      },
      secretKey
    );

    const response = await axios.post(
      "/api/notifications/acceptNotification",
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      toast.success("Doctor accepted notification");
      fetchNotifications(); // ✅ refresh notifications
    }
  } catch (error) {
    console.error("Accept notification failed", error);
    toast.error("Failed to accept notification");
  }
};
 const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <main>
      <MedicalAbstractBackground/>
      <DashboardNavbar notificationCount={notificationCount} />
    <header className="bg-dark shadow-sm">
        <div className="container-xl px-5">
          <h1 className="text-white py-3 mb-0 display-6"></h1>
        </div>
      </header>

      <div className="container-xl p-10 px-11" style={{ position: "relative", left: "100px" }}>
        <mwc-tab-bar style={{ marginBottom: "-1px" }} activeIndex="3">
          <Link to="/notifications" style={{ textDecoration: "none" }}>
            <mwc-tab label="Notifications" icon="notifications" stacked />
          </Link>
          <mwc-tab label="Notification" icon="notifications" stacked active />
        </mwc-tab-bar>

        <a href="/#/notification" className="text-decoration-none">
          <h3
  className="text-white display-6 d-flex justify-content-center align-items-center gap-2"
  style={{
    textAlign: "center",
    width: "100%",
    margin: "0 auto",
  }}
>
  <span className="material-icons" style={{ fontSize: "40px" }}>
    {/* notifications */}
  </span>
  NOTIFICATIONS
</h3>

        </a>

        <hr className="mt-0 mb-5" />
 
        <div className="container-xl px-4" style={{ padding: "10px", maxWidth: "800px", margin: "30px auto" }}>
          {/* <h3 className="text-black py-3 mb-0 display-6 d-flex align-items-center gap-2">
            Account Settings - Notifications
          </h3> */}

          {loading ? (
             <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>

          ) : notifications.length > 0 ? (
            <Stack spacing={2} mt={3}>
  {notifications.map((n, index) => {
    let bgColor = "";
  let borderColor = "";
  let textColor = "#000";

  // Determine colors based on notification type
 if (n.type === "CRITICAL_VITAL") {
  bgColor = "#ffebee";       // light red
  borderColor = "#d32f2f";
  textColor = "#b71c1c";
} else if (n.type === "WARNING_VITAL") {
  bgColor = "#fffde7";       // light yellow
  borderColor = "#fbc02d";
  textColor = "#795548";
} else if (n.type === "MISSED_VITAL") {
  bgColor = "#fff3e0";       // light orange
  borderColor = "#fb8c00";   // deep orange
  textColor = "#e65100";
} else {
  bgColor = "#e8f5e9";       // light green
  borderColor = "#388e3c";
  textColor = "#1b5e20";
}
  return (
    <Alert
      key={index}
      severity={n.type === "CRITICAL_VITAL" ? "error" : n.type === "WARNING" ? "warning" : "success"}
      variant="outlined"
      // onClick={() => handleMarkAsRead(n.id)}  // ✅ Mark as read on click
      sx={{
    position: "relative",
    borderLeft: `6px solid ${borderColor}`,
    backgroundColor: bgColor,
    color: textColor,
    borderRadius: 2,
    boxShadow: "1px 3px 8px rgba(0,0,0,0.1)",
    opacity: n.read ? 0.6 : 1,
  }}
    >
   
{/* <Tooltip title={n.read ? "Read" : "Mark as Read"} arrow> */}
   <Box
  sx={{
    position: "absolute",
    top: "4px",
    right: "6px",
    zIndex: 2,
  }}
>
{/* <Tooltip title={n.read ? "Read" : "Mark as Read"} arrow> */}
    <Box
     className="mark-read-box"
      onClick={(e) => {
        e.stopPropagation();
        if (!n.read) handleMarkAsRead(n.id);
      }}
      sx={{
    position: "absolute",
    top: 8,
    right: 8,
    cursor: n.read ? "default" : "pointer",
    zIndex: 10,
  }}
    >
      {n.read ? (
        <CheckCircleIcon sx={{ fontSize: 18, color: "#2e7d32" }} />
      ) : (
        <RadioButtonUncheckedIcon sx={{ fontSize: 18, color: "#9e9e9e" }} />
      )}
    </Box>
  {/* </Tooltip> */}
</Box>

  {/* </Tooltip> */}

 
      <AlertTitle>
        <strong>{n.subject}</strong>
        
      </AlertTitle>
      <Typography variant="body2">{n.message}</Typography>
      <Typography
        variant="caption"
        display="block"
        color="text.secondary"
        mt={1}
      >
        Timestamp: {n.timestamp} | Patient Name: {n.patientName} | Device: {n.deviceName}
      </Typography>

{role === "ROLE_DOCTOR" && n.pushNotificationId && (
  n.action === null ?  (
     
    <Button
      variant="contained"
      size="small"
      sx={{
        mt: 1,
        background: "#1A237E !important",
        color: "#fff !important",
        boxShadow: "none !important",
      }}
      onClick={(e) => {
        e.stopPropagation();
        handleAcceptNotification(n.id,n.doctorId);
      }}
    >
      Accept
    </Button>
  ) : n.action === "accepted" ? (
    <Button
      variant="contained"
      size="small"
      disabled
      sx={{
        mt: 1,
        background: "#035d0f !important",
        color: "#fff !important",
        boxShadow: "none !important",
        opacity: 0.8,
      }}
    >
      Accepted
    </Button>
  ) : null
)}

   {role === "ROLE_CARE_COORDINATOR" && n.type !== "MISSED_VITAL" && (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

    {n.pushNotificationId ? (
        <Button
      variant="contained"
      size="small"
       sx={{mt: 1,
      background: "#035d0fff !important",
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background:"#035d0fff !important",
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#035d0fff!important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#035d0fff !important",
        boxShadow: "none !important",
      },
    }}
      // sx={{ mt: 1, backgroundColor: "#035d0fff", color: "#fff" }}
      onClick={(e) => {
        e.stopPropagation();
        handleOpenAlreadyPushed(n.pushNotificationId);
      }}
    >
      Already Pushed
    </Button>

  ) : (
    <Button
      variant="contained"
      size="small"
      sx={{
      background: "#1A237E !important",
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background:"#1A237E !important",
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}
      onClick={(e) => {
        e.stopPropagation();
        handleOpenModal({ id: n.id, patientId: n.patientid });
      }}
    >
      Push to Doctor
    </Button>
  
)}
 {n.action === "accepted" && (
      <Typography
        sx={{
        fontSize: "13px",   
         fontWeight: "bold",
        color: "#000",
        mt: 1,
        whiteSpace: "nowrap",
      }}
      >
        Accepted by Doctor
      </Typography>
    )}
  </Box>
)}
                </Alert>
             );
})}
</Stack>

          ) : (
            <Typography
              variant="body1"
              align="center"
              color="text.secondary"
              mt={3}
            >
              No notifications found.
            </Typography>
          )}
        </div>
      </div>
  <DoctorModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        notificationId={selectedNotification?.id}
        patientId={selectedNotification?.patientId}
      />
     <AlreadyPushedModal
  open={alreadyPushedOpen}
  onClose={handleCloseAlreadyPushedModal}
  pushId={alreadyPushedId}
/>


    </main>
  );

}

export default NotificationDetails;


